import { createContext } from "react";

const TrucksContext = createContext();
TrucksContext.displayName = "TrucksContext";


export default TrucksContext;
